import type * as amplitude from '@amplitude/analytics-browser';
import { buildAnonymousAmplitudePayload } from './anonymousEvent';

export const applyAnonymousAmplitudePrivacy = (
  event: amplitude.Types.Event
): amplitude.Types.Event | null => {
  const anonymousEvent = buildAnonymousAmplitudePayload(event.event_type, {
    ...event.event_properties,
  });

  if (!anonymousEvent) {
    return null;
  }

  return {
    event_type: anonymousEvent.eventName,
    event_properties: anonymousEvent.properties,
    device_id: event.device_id,
    time: event.time,
    session_id: event.session_id,
    insert_id: event.insert_id,
  };
};
